import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import { ReactComponent as IconTrash } from '@/assets/svgs/trash-outline-medium.svg'
import rem from '@/utils/rem'

const PackageConfirmDeleteModal = ({
	visible,
	close,
	submit,
	title,
	text,
}) => {
	return (
		<Modal visible={visible} variant='medium' close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon--package-error'}>
										<IconTrash />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										<span>{title}</span>
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						<div style={{ fontSize: rem(14), textAlign: 'center' }}>
							{text}
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Left>
						<Button text="Cancel" submit={close} btnText customeHover />
					</CardConfigure.Footer.Left>
					<CardConfigure.Footer.Right>
						<Button error round text="Delete" submit={submit} />
					</CardConfigure.Footer.Right>

				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}

export default PackageConfirmDeleteModal
